<template>
  <main class="dashboard review-form">
    <div class="container-fluid container-fluid--max">
      <div class="card">
        <div class="card-body">
          <router-link :to="{ name: 'productRegistrations' }" tag="a" class="back btn btn-link uppercase smaller pl-0">
            <i class="back__icon fa fa-close mr-h" aria-hidden="true"></i>Retour
          </router-link>
          <section class="assist-review-form px-lg-5 mt-2">
            <h1 class="dashboard__title heading-primary text-center mb-5">Rédiger un avis pour votre assistance : <strong>#{{ id }}</strong></h1>
            <vv-observer tag="form" v-slot="{ invalid }" @submit.prevent="submit">
              <h2 class="dashboard__title heading-secondary">Note globale</h2>
              <hr class="separator-deco">
              <div class="row mt-4">
                <div class="col-md">
                  <label class="access-form__label">
                    Sur une échelle de 1 à 10, comment jugeriez-vous la marque et les produits Bestove ?
                    <abbr title="Ce champ est obligatoire">*</abbr>
                  </label>
                  <Rating :max-stars="10" v-model="params.bestove_rating" />
                </div>
                <div class="col-md">
                  <div class="form-group">
                    <label class="access-form__label">
                      Avez-vous des commentaires supplémentaires à apporter concernant la marque Bestove ?
                    </label>
                    <textarea class="form-control" v-model="params.bestove_comment"></textarea>
                  </div>
                </div>
              </div>
              <h2 class="dashboard__title heading-secondary">Prise en charge et accompagnement</h2>
              <hr class="separator-deco">
              <div class="row mt-4">
                <div class="col-md">
                  <vv-provider tag="div" class="form-group" rules="required">
                    <label class="access-form__label">
                      Votre problème a-t-il été compris et correctement analysé par notre équipe SAV ?
                      <abbr title="Ce champ est obligatoire">*</abbr>
                    </label>
                    <div class="custom-control custom-radio my-1">
                      <input type="radio" id="satisfactionYes" v-model="params.problem_analyzed" :value="true" class="custom-control-input">
                      <label for="satisfactionYes" class="custom-control-label text-secondary">Oui</label>
                    </div>
                    <div class="custom-control custom-radio my-1">
                      <input type="radio" id="satisfactionNo" v-model="params.problem_analyzed" :value="false" class="custom-control-input">
                      <label for="satisfactionNo" class="custom-control-label text-secondary">Non</label>
                    </div>
                  </vv-provider>
                  <label class="access-form__label">
                    Êtes-vous satisfait de l'accueil reçu par notre équipe SAV ?
                    <abbr title="Ce champ est obligatoire">*</abbr>
                  </label>
                  <Rating v-model="params.support_rating" />
                </div>
                <div class="col-md">
                  <div class="form-group">
                    <label class="access-form__label">
                      Avez-vous des commentaires à apporter sur votre poêle Bestove ?
                    </label>
                    <textarea class="form-control" v-model="params.problem_analyze_comment"></textarea>
                  </div>
                </div>
              </div>
              <h2 class="dashboard__title heading-secondary">Installation</h2>
              <hr class="separator-deco">
              <div class="row mt-4">
                <div class="col-md">
                  <vv-provider tag="div" class="form-group" rules="required">
                    <label class="access-form__label">
                      Êtes-vous passé par un professionnel agrée pour l’installation de votre poêle ?
                    </label>
                    <div class="custom-control custom-radio my-1">
                      <input type="radio" id="proYes" v-model="params.problem_solved" :value="true" class="custom-control-input">
                      <label for="proYes" class="custom-control-label text-secondary">Oui</label>
                    </div>
                    <div class="custom-control custom-radio my-1">
                      <input type="radio" id="proNo" v-model="params.problem_solved" :value="false" class="custom-control-input">
                      <label for="proNo" class="custom-control-label text-secondary">Non</label>
                    </div>
                  </vv-provider>
                </div>
                <div class="col-md">
                  <div class="form-group">
                    <label class="access-form__label">
                      Avez-vous un commentaire à formuler concernant la résolution de votre problème par l'équipe SAV ?
                    </label>
                    <textarea class="form-control" v-model="params.problem_solved_comment"></textarea>
                  </div>
                </div>
              </div>
              <h2 class="dashboard__title heading-secondary">Mise en service</h2>
              <hr class="separator-deco">
              <div class="row mt-4">
                <div class="col-md">
                  <vv-provider tag="div" class="form-group" rules="required">
                    <label class="access-form__label">
                      Êtes-vous passé par un professionnel agrée pour la mise en service de votre poêle ?
                    </label>
                    <div class="custom-control custom-radio my-1">
                      <input type="radio" id="startYes" v-model="params.started_by_professional" :value="true" class="custom-control-input">
                      <label for="startYes" class="custom-control-label text-secondary">Oui</label>
                    </div>
                    <div class="custom-control custom-radio my-1">
                      <input type="radio" id="startNo" v-model="params.started_by_professional" :value="false" class="custom-control-input">
                      <label for="startNo" class="custom-control-label text-secondary">Non</label>
                    </div>
                  </vv-provider>
                </div>
              </div>
              <div class="d-flex justify-content-center">
                <s-button :loading="loading" @submit="submit" :css-class="'px-5 btn-' + $mainColor" :disabled="invalid || loading">
                  Enregistrer
                </s-button>
              </div>
            </vv-observer>
          </section>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapState } from 'vuex'
import Rating from '@/components/ui/StarRating'

export default {
  name: 'SupportRequestReview',
  components: {
    Rating
  },
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },
  data () {
    return {
      loading: false,
      params: {},
      error: {}
    }
  },
  computed: {
    ...mapState(['currentClient', 'clientAuth'])
  },
  methods: {
    submit () {
      this.loading = true
      this.$http.post('/clients/' + this.currentClient.id + '/support_requests/' + this.id + '/support_reviews', this.params, {
        headers: this.clientAuth
      }).then(resp => {
        this.$store.dispatch('fetchProductRegistrations').then(() => {
          this.$store.dispatch('fetchReviews').then(() => {
            this.loading = false
            this.$router.push({ name: 'reviews', query: { id: resp.data.id }, hash: `#support_review${resp.data.id}` })
          })
        })
      }).catch(err => {
        this.loading = false
        this.error = {}
        if (err.response.status === 422) {
          let e = err.response.data
          this.error = _.reduce(e, (result, value, key) => {
            result[key] = value[0]
            return result
          }, {})
        }
      })
    }
  }
}
</script>
